import { inject, Injectable } from '@angular/core'
import { CanActivate, CanActivateChild, GuardResult, MaybeAsync, Router } from '@angular/router'
import { AuthService } from '@modules/auth-module/services/auth.service'

@Injectable({
	providedIn: 'root',
})
export class AuthorizedGuard implements CanActivate, CanActivateChild {
	private readonly _authService: AuthService = inject<AuthService>(AuthService)
	private readonly _router: Router = inject<Router>(Router)

	private _checkAuthorized(): boolean {
		if (this._authService.isAuthorized) return true

		this._router.navigate(['/auth/sign-in'])
		return false
	}

	canActivate(): MaybeAsync<GuardResult> {
		return this._checkAuthorized()
	}

	canActivateChild(): MaybeAsync<GuardResult> {
		return this._checkAuthorized()
	}
}
